import { Button, Row, Spin, Menu, notification } from 'antd';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react';
import ActionHeader from '../Common/ActionHeader';
import { useParams } from 'react-router-dom';
import {
  getUnitOffer,
  deleteUnitOffer,
  addUnitOffer
} from '../../services/unitOfferService';
import FeedbackInfo from './FeedbackInfo';
import UnitOfferEdit from './UnitOfferEdit';
import UnitOfferInfo from './UnitOfferInfo';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import WarningModal from '../Common/WarningModal';
import { setCurrentUnitOffer } from '../../actions/unitOffer';

function UnitOffer() {
  const { id } = useParams();
  const [unitOffer, setUnitOffer] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isRefreshModalOpen, setIsRefreshModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const history = useHistory();
  const [status, setStatus] = useState({
    type: 'LOADING',
    message: 'Loading data.'
  });
  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

  useEffect(() => {
    fetchData();
  }, []);

  const deleteUnitOfferOnClick = async () => {
    toggleDeleteModal();
    setStatus({ type: 'LOADING', message: 'Loading Data' });
    await deleteUnitOffer({ unitOfferId: unitOffer.unitOfferId })
      .then((response) => {
        console.log('Successfully Deleted! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Unit Offer Deleted successfully!'
        });
        history.push(`/course-offer/${unitOffer.courseOfferId}`);
        notification['success']({
          message: `Unit Offer ${unitOffer.code} Deleted!`,
          duration: 5
        });
      })

      .catch((err) => {
        console.log('Theres an error deleting the unit offer data!');
        alert('Theres an error deleting the unit data!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const refreshUnitOfferOnClick = async () => {
    toggleRefreshModal();
    setStatus({ type: 'LOADING', message: 'Loading Data' });
    await deleteUnitOffer({
      unitOfferId: unitOffer.unitOfferId
    })
      .then(async (response) => {
        notification['success']({
          message: 'Unit Offer Deleted',
          duration: 5
        });
        const unitOfferPayload = {
          unitId: unitOffer.unitId,
          startDate: unitOffer.startDate,
          endDate: unitOffer.endDate,
          courseOfferId: unitOffer.courseOfferId,
          feedbackLink: unitOffer.feedbackLink,
          surveyId: unitOffer.surveyId,
        };
        await addUnitOffer(unitOfferPayload)
          .then((response) => {
            notification['success']({
              message: 'Unit Offer Created',
              duration: 5
            });
            notification['success']({
              message: 'Refresh all done!',
              duration: 5
            });
            history.push(
              `/unit-offer/${response.data.unitOffer.unitOfferId}`
            );
          })
          .catch((err) => {
            alert(
              'Theres an error creating the unit offer, it might have been deleted though!'
            );
            setStatus({ type: 'ERROR', message: 'Something went wrong!' });
          });
      })
      .catch((err) => {
        console.log('Theres an error deleting the unit offer data!');
        alert('Theres an error deleting the unit data!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  async function fetchData() {
    setStatus({ type: 'LOADING', message: 'Loading Data' });
    await getUnitOffer(id)
      .then((response) => {
        if (response.data.unitOffers.length) {
          setUnitOffer({
            ...response.data.unitOffers[0],
            startDateFormatted: moment(
              response.data.unitOffers[0].startDate
            )
              .utc()
              .local()
              .format(dateFormat),
            endDateFormatted: moment(response.data.unitOffers[0].endDate)
              .utc()
              .local()
              .format(dateFormat)
          });
          setStatus({
            type: 'SUCCESS',
            message: 'Data received sucessfully!'
          });
        } else {
          setStatus({ type: 'ERROR', message: 'Invalid unit offer id!' });
        }
      })
      .catch((err) => {
        console.log('Theres an error fetching data!');
        alert('Theres an error fetching data!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  function toggleEditModal() {
    setIsEditModalOpen((prev) => !prev);
  }
  function toggleRefreshModal() {
    setIsRefreshModalOpen((prev) => !prev);
  }
  function toggleDeleteModal() {
    setIsDeleteModalOpen((prev) => !prev);
  }

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => toggleEditModal()}>Edit</Menu.Item>
      <Menu.Item onClick={() => toggleRefreshModal()}>Refresh</Menu.Item>
      <Menu.Item onClick={() => toggleDeleteModal()}>Delete</Menu.Item>
    </Menu>
  );

  function updateUnitOffer(data) {
    setUnitOffer((prev) => {
      const returnObj = {
        ...prev,
        ...data,
        startDate: moment(unitOffer.startDateFormatted, dateFormat).format(
          dateFormat
        ),
        endDate: moment(unitOffer.endDateFormatted, dateFormat).format(
          dateFormat
        )
      };
      return returnObj;
    });
  }

  if (status.type === 'LOADING') return <Spin size="large" />;

  if (status.type === 'ERROR')
    return <Text type="danger">{status.message}</Text>;

  return (
    <div>
      <Row justify="space-between">
        <h1>Unit Offer {unitOffer.unitOfferId}</h1>
        <div>
          <ActionHeader actionMenu={actionMenu} />
        </div>
      </Row>
      <UnitOfferInfo unitOffer={unitOffer} />
      <FeedbackInfo
        unitOfferId={unitOffer.unitOfferId}
        unitOfferStartDate={unitOffer.startDateFormatted}
      />
      <UnitOfferEdit
        unitOffer={unitOffer}
        isOpen={isEditModalOpen}
        toggle={toggleEditModal}
        updateUnitOffer={updateUnitOffer}
      />
      <WarningModal
        isOpen={isRefreshModalOpen}
        toggle={toggleRefreshModal}
        onClick={refreshUnitOfferOnClick}
        warningButtonText={'Refresh Unit Offer'}
        warningText={
          'Refreshing this unit offer will delete and re-create this unit offer with the current subunits. Are you sure you want to proceed?'
        }
      />
      <WarningModal
        isOpen={isDeleteModalOpen}
        toggle={toggleDeleteModal}
        onClick={deleteUnitOfferOnClick}
        warningButtonText={'Delete Unit Offer'}
        warningText={
          'Are you sure you want to delete this unit offer? - This action cannot be undone.'
        }
      />
    </div>
  );
}

export default UnitOffer;
